export default {
  pending: "Pendente",
  paid: "Pago",
  approved: "Aprovado",
  partial_payment: "Pagamento parcial",
  shipping_informed: "Entrega informada",
  waiting_invoice: "Nota fiscal solicitada",
  invoiced: "Faturado",
  invoice_error: "Erro ao gerar nota fiscal",
  shipped: "Em Trânsito",
  shipping_error: "Despacho incorreto",
  delivered: "Entregue",
  canceled: "Cancelado",
  under_review: "Sob análise",
  expiredSendSla: "Envio expirado",
  expiredDeliverySla: "Entrega expirada",
  sendToday: "Enviar Hoje",
  f470a016e1ffd4e815ec068389483d05: "Abx Climatização",
  "06fbad3480cf83d439cc271e86eaa82b": "Amazon",
  c44d12a2fd31dc5b9c35f94fc69f8d9b: "Antes de Mim",
  "041c45aceeecf5bc1ec173012ceb2dae": "B2W",
  "6bd10e36e53ed4466d477c6b275c397b": "B2W V2",
  c65017d475d2a585956dbc4f7d66173c: "Bling",
  de5b3c616d7ba2191eaf10441c29ad54: "Buscapé",
  "048e9f2efcf6659867648b43c2b7a7ca": "C&amp;A",
  "7c0d4545e312d0c732807c7b8ab25fdd": "Carrefour",
  "76b6a6897c736f4047c7099a8a7ff210": "Catálogo",
  c0972e1d1e2ed46ba76639e52f931b37: "Centauro",
  a106d72f997e5d3c8a08ce5c32e849b7: "CiaShop - Integração",
  adcb048802cc420eeba779cf5a084243: "Cnovav2",
  "117db8ea06eca0f5af5602e9939ce601": "Correios",
  c8519513bcc4bad2df82f931e7292248: "Dafiti",
  ec2fa4717215a865fa804cb71066b660: "Eskolare",
  "1b4cfd70c334154d816ee83d4fae986a": "Fotter",
  "1169c8db2365e89fa8fc25cbff611908": "Frete Planilha",
  d5260419e36a720e451b71e79d5f5d0b: "Importador de Fotos",
  f2638deaba9395e9ff728385530cab8b: "Intelipost",
  "9f2c96d28e70e03e23ff0ae35e770db7": "KPL (Ábacos) ERP",
  d7363d1e13afc21e308e3ec62e882cb0: "Leitor de XML",
  f3f0b1de6fe197aaccf5c198c2496e12: "Loja Integrada ",
  "9e5e25b65aba5508dce1697c084ce7a2": "Madeira Madeira",
  "7de4f283401c91fee5a86e9f6a56ae98": "Magazine Luiza",
  db88c2ffe78f0992c1d7d7371f58ca47: "MercadoLivre",
  "81498500a3fea85ca24c3a9a1313f867": "MercadoLivreDev",
  "373bd948d42e6923b97e67d0ce1aa4ad": "Millenium ERP",
  "3bc5b02d367af07061257df2316d1707": "Mobly",
  "1522c5fb1ec6d49d43cae528bfb8f3cd": "Multiplus",
  "1e1f6881d288028104c74aa87910452b": "MyMarketplace",
  aaf2eff2c5c8cdb0fb7becfddb57d7dd: "Netshoes",
  "33fa51547c27e4d751816b2707d8de76": "OpenCart API",
  "2aac763e61756161c1252ec8ded8a52d": "OPTE+",
  "9d510fbf530d324509298323e9029efd": "Outlet do Músico",
  "6e19e8b91aa41d1911cf24ef4ae265e7": "Pedidos",
  "5c3bb167c1d19e8b6cb1f5b67ae75d0a": "Precificação",
  e522d2e88e08dd7e276b968e7e7a1c57: "Produtos",
  "70d54252876996a817b5baa929b8eb74": "Respostas Automáticas",
  "54ee548bbbf04aca3ff627e8637b6e9a": "Ricardo Eletro ",
  bc1b195005f82de4e70dc41431c12282: "SAC",
  b2f0237ec6f53e2037fd9e0db637f64d: "Saraiva",
  "64b647388d34d5fb5d8e01a9b411c43e": "Shopfacil",
  f57430ab5e54dace7b04cae15ff53a9b: "Vtex Loja",
  "91dbdde41a4a3393fd4d781dbfe35f4d": "WalMart",
  ace8364d37494ae03da367fde88797f5: "WalMart V2",
  "5de98c314871a4f1970eb387e937db5c": "XtechCommerce",
  bde47c584bff465748476414cb6ba727: "Zoom MarketPlace",
  a04d2fc57682feb92c2453fe0f92e055: "Magento Plugg.To",
  e1f0f0d4c006a57b32b48ae14c35b3b0: "Enriquecedor de Dados",
  "8689600d46bc6f851edbeb794e84d017": "Magento - Pluggto - Teste ",
  c2fbd68743e449c99b205a491fd12173: "magentodev",
  "2de2f72c572619c34ae7020604667ead": "Magento Dev",
  "5a2ab8f9dc48e01c1bc35233fbf0ac59": "Loja 1",
  "6b0b5b58241d67917eb673d8c81d9e00": "MagentoDev",
  "1f01df429aea316f83b0464b95217f5d": "DevMagento",
  "84e3978afc4089ee5bffcb921a849e6d": "TIny - TESTE",
  "48ea7dc1aee5c89ef10bb5ab632eea6e": "magento-teste",
  "908e352eb7ab8c45d83d208c2cf419b9": "wBuy E-commerce - Homolog",
  e7b46199ffd26fdec9103d7b30352c51: "Opencart - Teste",

  //Applications q estavam faltando
  NTJhYTI3MTc4MDYyZjNk: "Painel",
  "788ceba032b67a0c12767667c09b24d3": "Opeco",
  "64c86d1fe6adf98602994e2bec41bfe5": "Cnova",
  "8dffd793fb3474b9d8e96b77d1765a8e": "b2w-local-teste",
  bc0661a61972734ce08811c6f3b5c3c0: "BlingDevLocal",
  e076f6a03691398773ed79c3e09aebaa: "Millenium",
  "1411557987c12efd8ee1da6bf481fde1": "CorreiosDev",
  "4ab7e66d63b4331b89df9366d365d1d5": "Novo Plugin de Teste",
  "5224f670b019ce61b0c8ad8d1d87d9a2": "VtexMkt",
  a2685d1d525c37ce3bbdd15d4ca68cca: "App de teste",
  "32b124b71880fe446b7ea40e9a24f531": "Loja Virtual",
  "1f57fb5127ee7060993a7b5b8e2ac8a7": "Sabrina",
  "14cd0770b0746009ba330b1d2eb23114": "Kanui",
  "860f7a809d8252f0536c6135aab2a4a6": "Gustavo ML",
  "5d614723ca4b002723489c67d026be96": "Dafiti Dev",
  "8f92e9052fda9ccf3dc6f465f4e52608": "Integração TOTVS",
  "2d6ce830051c99e5f784afebf8b92414": "Mercado Shops",
  "28e15d02a68d03ffbb0ebf3197fc7a85": "Nota Fiscal eletrônica",
  "4c1e304ddf32b203faaff73b71465964": "Tricae",
  c3a64c4e8a1240ccf467cd27e45bfc9e: "KPL ERP",
  b532220a1c1cb31636d8e69b8d7c3831: "Integracao-TOTVS",
  d56dfc41506867e565563b11e8a2ee00: "Emissor NFe",
  c140b4d8a2ff1f067139d132abad9fd8: "Emissor NFe 2.0",
  f992b89391c706fd3ffb2b52b619d314: "CiaShopDev",
  "63af8256cced7335f8d4ede9175a2352": "Mercado Livre Perguntas Gerenciador",
  "770b50e49ee1f0899e295e5d672a5479": "MeuAr",
  "22cf65484dea17d9c6d198910f13f3b0": "TMWxD",
  "417d68fecb9d6f2cfb2cce2e443682e1": "Vtex ERP",
  cce679d86cf6e51fdf82bc03bdef821f: "Vasculhei",
  a6e2b1f8e36e294ab4dbcd7852c4e53c: "Dafiti Argentina",
  f127421daedbe7b427f8b6b24648cad2: "Rede Mercosul",
  "2bce91642941339844cec01e1803abcf": "XML DEV",
  "2ffe66723c1431403cbb98a463d8e981": "Frenet",
  "220b16e9718ec487ad8653ba2554f143": "TMWxD-Decora",
  "4211b03272e07aa35f9292f5299a8bf1": "CaptarePRO",
  "9b80a0ddd78bd146d289987b8715a8da": "Marketplace Tiago",
  "01b176050c4dbb4eeb347dfa48d1366e": "Marketplace Felipe",
  "22a8e2f2d09d5801b4f4fd488049c54e": "Frete Rápido",
  a141063a618462e7482b87267829ba8d: "InfoAr",
  "4fbc841004d54d64c76870c478aafbdb": "Stoom",
  "4cfb7397a57dd15e20db8d14424a8a88": "shoppub",
  "0f6fc3f02a0792d6c599866ca6da60e7": "Integração cURL PHP Plugg.to via API",
  "2d1ef640f8e72c38fafd51f47849198e": "UoouCommerce",
  "032257a41e63392f239f1e26ec059faf": "TMWxD-Lojamatel",
  "4309dd5a97406d56ea077eb426abb718": "Integração com a Livelo",
  "7b98c37b915608c664ca5fe3fba26782": "Virtualskateshop",
  cc5771deee29d580af678ac98ccf7f75: "Virtualskateshop.com.br",
  d6a68e0affce349e1c05d25773b55e0c: "APP ERP Linx to Plugg.to",
  c8bce9aeda7bf8401594ffb309308e7a: "Mensageria",
  f02097761c9acc7bb24f335f14765183: "Myvillage Marketplace",
  dc3eb628ee1581c27a42f56dbbecf881: "Teste Fone Shop",
  f92756998ae69177db4bafee7110e94f: "rimo_market",
  cbda2d906cc84d50f473ca4169aa76cb: "Mobly-Gaya",
  ef278fc7472013f3204ccec7cb42bc6a: "TMWxD-PCPerformance",
  "9f8502dc364860c4a3b4601690c09b08": "Syncmoze",
  c0d399079eed33059c33d34ad9cea0fb: "OtimanutriAPI",
  ff67586a7d3eed262db3351f003000a3: "Manhattan Project",
  b259c24468f33149d40bbadefed0bd71: "Integração Plugae",
  fa80a6eec9842e0eebcc5e7d635e15d4: "System PD",
  "6f2682f98ecfdfc852935e37b53c1cde": "Notificações por Email",
  "7fb8a3c327fdefecc4f24df9f0d5a489": "SSPlus",
  "34a33bbdfdf0a244ef50f49046486e76": "RoupaShop",
  "26faaee569b0b2faf74864d4b2c5af42": "Integração Polihouse APP",
  "27b9889bf97b956e57da4d98da5b1f5e": "CoreV2",
  c6786d7c5365ec9831e3eea334b1d752: "Integração Exato Sistema",
  "7206d07797468b82d906a443e3245ca1": "Teste TI CCell",
  "14c3df43aee61c4c106e016bc3ff5df1": "CenterCell",
  "863f0415501c6a2ce689b4e9e5548614": "teste",
  f413868cfaa8c99ab65f5673a21a6880: "Integração EVG Plugg.to via API",
  cd7122a11dd83ee7b8aa0995ee602e20: "ERP_WHAL",
  "1d937a0ca36a5bff3b4fa3d113c72328": "Integração Cristina Fashion Brands",
  d0511a316e6689725d913a4bb63fa72a: "VitalCare MarketPlace",
  "114099569c9eaf57995531d5f8b852b8": "System LM",
  e572715c9c385b2b62728544d0582744: "SYSTEM MX",
  f45fb8d8a606a1fdc8d7c0d7c5942d26: "wBuy e-commerce",
  "70e7e447bf99c9ce843739e7a55bc1f7": "Toplojas",
  "3ba0b63743564833cf5a7bd13c31d25c": "teste_cc",
  "3ba0b63743564833cf5a7bd13c31d25c": "teste_ccas",
  "8e9258d1a0d7e923438750d6f3f784ea": "BrERP",
  "1119b5cabba83e38ec69367316ec9cb6": "aqx aplicação80",
  "0c1bb9fd7fae738ec8a19da24dcd8696": "aqx aplicação3232232",
  aa858b8f96a9651def9d5e2cdcdc5e19: "sadadsasdsadsadsa",
  "3b31f8fe8322c1e9816497dfb3f9f290": "sadadsasdsadsadsaxx",
  c7572fd2e2b1ffc3b5cea2a5d40373d6: "sadadsasdsadsadsaxx22",
  "57e1377edcf3b7c6bc62c4a70e64a84d": "saysasausuhashaus",
  d7aec26d9a63e97d0328df63c90c9ed6: "Vivara Teste",
  ddbdeb0e60f52c998d7d25d72c0000f0: "teste aplicaça",
  "158feb423d768adf6071466897b0b050": "Sinc Master",
  "3c022dfda592c772dfdcd1c75d56b853": "TrackCash",
  "5177f4501ad4b3f4f49a55aa470903bd": "Atena.ai",
  ff7d9cb152549fb4e05bb956909742a4: "NotaFiscal",
  "43da9b5c5bbaa80361057a9fdc89d872": "Setta",
  "64a9dede82f16b625f2336d9829e48a1": "Setta MarketPlace",

  //novos
  picking: "Separação",
  waiting_picking: "Pendentes de separação",
  processing_picking: "Em Separação",
  pending_invoice: "Separados",
  waiting_invoice: "Aguardando Nota Fiscal",
  processing_invoice: "Aguardando Pagamento Gnre",
  waiting_expedition: "Pronto para embalar",
  processing_expedition: "Aguardando retirada",
  shipping_error: "Despacho Incorreto",
  shipped: "Em Transito",
  delivered: "Entregue",
  has_label: "Etiqueta",
  has_gnre_doc: "GNRE",
  has_invoice_doc: "NFE",
  // Dispute status
  requested_dispute: "Disputa aberta",
  processing_dispute: "Disputa em andamento",
  finished_dispute: "Disputa finalizada",

  "The access token provided is invalid.": "O token de acesso é inválido",
  "The access token provided has expired.": "O token de acesso expirou",

  manual: "manual",
  third_contract: "contrato de terceiro",
  "fulfillment": "fulfillment",
  own_contract: "contrato proprio",
  pickup_store: "entrega pela loja",
  drop_shipping: "entrega pelo fornecedor",

  "msg.voucher.error": "Erro de validação: o valor descrito em 'payment_type' não é valido, consulte nossa documentação.",
  "credit_card": "Cartão de Crédito",
  "CreditCard": "Cartão de Crédito",
  "Credit Card": "Cartão de Crédito",
  "visa": "Visa",
  "master": "Mastercard",
  "account_money": "Dinheiro em Conta",
  "Pix": "Pix",
  "pix": "Pix",
  "amex": "American Express",
  "SParcelado": "Pagamento Parcelado",
  "consumer_credits": "Créditos ao Consumidor",
  "installments": "Parcelamento",
  "elo": "Elo",
  "GiftCertificate": "Vale Presente"
};


// WEBPACK FOOTER //
// ./resources/assets/js/languages/BR.js